import { render, staticRenderFns } from "./BtnConfirmar.vue?vue&type=template&id=6fa96342"
import script from "./BtnConfirmar.vue?vue&type=script&lang=js"
export * from "./BtnConfirmar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports